import React from 'react';
import { useAchievementStore } from '../stores/achievementStore';

// ponytail: AchievementContext thin facade mapping to achievementStore.
export const useAchievements = () => {
  return useAchievementStore();
};

export const AchievementProvider = ({ children }) => {
  return <>{children}</>;
};

export default useAchievementStore;
